import type { CompatibleLanguage } from '@seek/ca-myprofile-utils';

import { getLanguagePrefixedPath } from './getLanguagePrefixedPath';

export const pathShouldNotRedirectToSignIn = (
  pathname: string,
  language?: CompatibleLanguage,
) => {
  const paths = [
    getLanguagePrefixedPath(language, '/settings/notifications/unsubscribe'),
    getLanguagePrefixedPath(language, '/settings/notifications/resubscribe'),
  ];
  return paths.includes(pathname);
};
